import React from 'react';
import projectImage from '../img/P2.png';
import Navbar from './Navbar';
import { motion } from "framer-motion";
import { FaGithub, FaFigma } from "react-icons/fa";
import { Link } from "react-router-dom";

const Project = () => {
  return (
    <div>
      <Navbar />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        id='about'
        className="mx-auto px-4 md:px-20"
      >
        <h2 className="text-4xl sm:text-4xl font-bold pl-4 pt-20">Project Title : Company Management System UI/UX</h2>

        <div className="max-w-screen-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 items-center justify-center h-full py-10">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="h-75 w-75 ml-4 mr-4 pr-4"
          >
            <img
              src={projectImage}
              alt="Project Screenshot"
              className="mx-auto w-full shadow-2xl"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="flex flex-col justify-center h-full   "
          >
            <div className="items-center justify-center">
              <h2 className="text-3xl sm:text-4xl font-bold pl-4">Key tools and technologies:</h2>
              <ul className="flex flex-wrap justify-center pb-5 text-xl sm:text-2xl font-bold pt-2">
              <li className="pl-10">Figma</li>
              </ul>
            </div>

            <div className="items-center justify-center">
              <ul className="flex justify-center pb-5 text-xl sm:text-2xl font-bold">
                <li className="pl-4">
                <Link to="https://www.figma.com/files/project/100384219/Team-project?fuid=1087804051819283768">
                      <FaFigma size="3.3rem" />
                    </Link>             </li>
               
              </ul>
            </div>
          </motion.div>
        </div>

        <h1 className="text-4xl sm:text-3xl font-bold pt-10 pl-4">Project Description:</h1>
        <div className="px-4 md:px-20">
          <p className="py-4">
          In my college UI/UX project, I embarked on an exciting journey of creating a Trending App prototype. This comprehensive project involved a series of tasks, from meticulous requirement gathering to crafting personas, designing prototypes, and creating wireframes. Our main objective was to analyze existing trending apps in the market and leverage that knowledge to enhance the UI/UX design of our own app.

<br/>The project commenced with an in-depth requirement gathering process, where we identified the key functionalities and features to be incorporated into our Trending App. We considered user preferences and market trends to ensure the app's relevance and appeal.

<br/>Creating personas played a crucial role in understanding our target audience better. By empathizing with potential users, we gained valuable insights into their needs, preferences, and pain points. This enabled us to design an app that catered to their specific requirements, thereby improving overall user satisfaction.

<br/>The prototype development phase was a creative endeavor, as we explored various design elements and layouts to craft an intuitive and aesthetically pleasing app. We focused on creating a seamless user flow that made navigation effortless and engagement enjoyable.

<br/>Wireframing played a key role in translating our ideas into a tangible form, allowing us to refine the app's layout and interactions. We meticulously iterated on the wireframes, ensuring every element served a purpose and contributed to an enriching user experience.

<br/>Throughout the project, user feedback was at the core of our design refinement process. We conducted multiple user testing sessions, incorporating valuable feedback from various users. This iterative approach helped us fine-tune the app's design, making it more user-friendly and efficient.
 </p>

          {/* <div>
            <button
              type="button"
              className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
            >
              Video Link
            </button>
          </div> */}
        </div>
      </motion.div>
    </div>
  );
};

export default Project;
